"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../../index");
function filterToAxiosParams(filter) {
    var startDate = filter.startDate, endDate = filter.endDate, locationIds = filter.locationIds, productId = filter.productId, sortField = filter.sortField, sortDirection = filter.sortDirection, includeDeletedProducts = filter.includeDeletedProducts;
    var params = {
        productId: productId,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        locationIds: locationIds ? __spread(locationIds) : undefined,
        sortField: sortField,
        sortDirection: sortDirection,
        includeDeletedProducts: includeDeletedProducts
    };
    return params;
}
exports.ReportAPI = {
    // sales v2
    getSales: function (companyId, query) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, index_1.axios.get("/api/v1/company/" + companyId + "/reports/V2/sales", {
                            params: __assign({}, query)
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    },
    getSalesBySource: function (companyId, query) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, index_1.axios.get("/api/v1/company/" + companyId + "/reports/V2/sourceSales", {
                            params: __assign({}, query)
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    },
    // Sales graph
    getGraphValues: function (companyId, startDate, endDate, groupBy, locationIds) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/api/v1/company/" + companyId + "/reports/graph";
                return [2 /*return*/, index_1.axios.get(url, {
                        params: {
                            startDate: startDate.toISOString(),
                            endDate: endDate.toISOString(),
                            groupBy: groupBy,
                            locationIds: locationIds ? __spread(locationIds) : undefined
                        }
                    }).then(function (response) {
                        var graphValues = response.data.graphValues;
                        return graphValues;
                    })];
            });
        });
    },
    // Financial reports
    getSalesBreakdown: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Sales.Breakdown", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getSalesTotals: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Sales.Totals", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getDiscountBreakdown: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Sales.Discounts", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getTaxBreakdown: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Sales.TaxBreakdown", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getTransfersBreakdown: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Sales.Transfers", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getVendorsBreakdown: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Sales.VendorBreakdown", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getSalesByDay: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Sales.SalesByDay", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getSalesByDayOfWeek: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Sales.SalesByDayOfWeek", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getSalesByHour: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Sales.SalesByHour", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    // Product reports
    getTopSellingProducts: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Product.TopSellingProducts", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getTopSellingCategories: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Product.TopSellingCategories", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getTopSellingVendors: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Product.TopSellingVendors", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getProductSummary: function (companyId, productId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                filter.productId = productId;
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Product.ProductSummary", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    // Customer reports
    getCustomerSummary: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Customer.Summary", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getTopCustomers: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Customer.TopCustomers", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    // Employee reports
    getEmployeeHours: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Employee.Hours", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getEmployeeSales: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Employee.Sales", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getEmployeeDiscounts: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Employee.Discounts", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getCategoryInventoryValue: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Inventory.InventoryValue", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getProductInventoryValue: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Inventory.ProductInventoryValue", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getInventoryRestockReport: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Inventory.InventoryRestockReport", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getInventorySummaryReport: function (companyId, filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, index_1.axios.get("/api/v1/company/" + companyId + "/report/Inventory.Summary", {
                        params: filterToAxiosParams(filter)
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    },
    getOnlineDiscrepancy: function (companyId, query) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, index_1.axios.get("/api/v1/company/" + companyId + "/reports/V2/onlineDiscrepancy", {
                            params: query
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    }
};
//# sourceMappingURL=ReportAPI.js.map